import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CHANGES, markChangesSeen } from "../components/whatsNewChanges";
import { ChangeList } from "../components/WhatsNewButton";
import "../features/bomScheduler/FileUpload.css";

// Every What's new entry, grouped by month (the date of each entry, e.g. "Sep 2026"), newest first
export default function WhatsNew() {
  useEffect(() => {
    markChangesSeen();
  }, []);

  const months = CHANGES.reduce((groups, change) => {
    const last = groups[groups.length - 1];
    if (last && last.date === change.date) last.changes.push(change);
    else groups.push({ date: change.date, changes: [change] });
    return groups;
  }, []);

  return (
    <div className="whats-new-page card border-0 shadow-sm mb-4 text-start">
      <div className="card-body p-4">
        <Link to="/" className="small">&larr; Back to BOM Compare</Link>
        <h3 className="upload-panel__title mt-2 mb-1">What's new</h3>
        <p className="upload-panel__subtitle mb-4">All the changes to BOM Compare, newest first.</p>
        {months.map((month) => (
          <section key={month.date} className="mb-4">
            <h6 className="whats-new-page__month">{month.date}</h6>
            <ChangeList changes={month.changes} showDate={false} />
          </section>
        ))}
      </div>
    </div>
  );
}
